import React from 'react';
import PropTypes from 'prop-types';

// Components
import InfoPanel from './InfoPanel';
import SetStatusWidget from './SetStatusWidget';
import HubStatusWidget from './HubStatusWidget';
import StaffWidget from './StaffWidget';
import AlertUpdateWidget from './AlertUpdateWidget';
import InfoDialog from './InfoDialog';

import LineItem from './LineItem';

import { DeviceTypes, isNull } from '../constants';
import { T, FONT_MONO, INDICATOR_TEXT } from '../constants/tokens';

const HEADER = (room) => {
  const status = room.getAlertStatus();

  return (
    <>
      <div style={{ fontSize: 20, fontWeight: 600, lineHeight: '28px', letterSpacing: '-0.4px', color: T.ink }}>
        {room.getIdentifier()}
      </div>
      {/* AlertType has no `name` — this read undefined before and rendered
          "undefined Status". */}
      <div
        style={{
          fontFamily: FONT_MONO,
          fontSize: 12,
          fontWeight: 500,
          lineHeight: '16px',
          textTransform: 'uppercase',
          color: T.muted,
          marginTop: 2
        }}
      >
        {status?.getDashboardStatus() ?? 'Unknown'}
      </div>
    </>
  );
};

const CHILDREN = (room) => {
  const lastSeenStaff = room?.getLastSeenBadges()?.map(badge => badge.getBelongsTo()) || [];
  const hubs = room.getHubs() ?? [];
  const allOn = hubs.length > 0 && hubs.every((hub) => hub.getIsConnected());

  return (
    <>
      <LineItem description='Status' value={room.getAlertStatus()?.getDashboardStatus() ?? 'Unknown'} />
      <LineItem description='Badges in room' value={String(room.getLastSeenBadges()?.length ?? 0)} mono />
      <LineItem description='Hubs' value={hubs.map((h) => h.getSerialNumber()).join(', ')} mono />
      <LineItem
        description='Hub connection'
        value={hubs.length === 0 ? null : (allOn ? 'All connected' : 'One or more offline')}
        tone={hubs.length > 0 && !allOn ? INDICATOR_TEXT.error : null}
        last
      />

      {hubs.length > 0 &&
        <HubStatusWidget hubs={hubs} isInfoPanel />
      }

      {lastSeenStaff.length > 0 &&
        <StaffWidget displayType={DeviceTypes.ROOMS} style={{ margin: '30px 0px 30px 0px' }} staff={lastSeenStaff} />
      }
      <AlertUpdateWidget updates={room.getAlertUpdates()} />
    </>
  );
};

const FOOTER = (onSetStatus) => {
  return (
    <SetStatusWidget onSetStatus={onSetStatus} />
  );
};

export default function RoomInfoPanel({ room, onSetStatus, isMobile, handleClose/*, setupMode*/ }) {
  return isMobile ? (
    <InfoDialog
      statusColor={room.getAlertStatus()?.getColor()?.main}
      header={HEADER(room)}
      footer={FOOTER(onSetStatus)}
      handleClose={handleClose}
      open={!isNull(room)}
      editHref={null /*setupMode ? '/admin/rooms/' + room.getID() : null*/}
    >
      {CHILDREN(room)}
    </InfoDialog>
  ) : (
    <InfoPanel
      statusColor={room.getAlertStatus()?.getColor()?.main}
      header={HEADER(room)}
      footer={FOOTER(onSetStatus)}
      editHref={null /*setupMode ? '/admin/rooms/' + room.getID() : null*/}
    >
      {CHILDREN(room)}
    </InfoPanel>
  );
}

RoomInfoPanel.propTypes = {
  room: PropTypes.object,
  onSetStatus: PropTypes.func,
  isMobile: PropTypes.bool,
  handleClose: PropTypes.func,
  setupMode: PropTypes.bool.isRequired
};
